// Sentry para el frontend (Momo).
// Reporta al MISMO proyecto de Sentry que el backend (kingston), pero TODO queda
// etiquetado como "frontend" (environment + tags) para que no se mezcle con los
// errores de Python del backend.
import * as Sentry from "@sentry/vue";

// El DSN es PÚBLICO (se embebe en el bundle del navegador, cualquiera puede verlo).
// Debe configurarse solamente en el build de producción.
const SENTRY_DSN = process.env.VUE_APP_SENTRY_DSN;

function isProd() {
  if (process.env.VUE_APP_SENTRY_ENV) {
    return process.env.VUE_APP_SENTRY_ENV === "production";
  }
  if (typeof window === "undefined") return false;
  return /(^|\.)clipr\.tv$/i.test(window.location.hostname);
}

// Detecta navegadores in-app (Instagram / Facebook / TikTok / Line / webview de
// Android), donde el "Failed to fetch" es mucho más frecuente. Se usa como tag
// para poder correlacionar fallos con el origen del tráfico (anuncios).
export function detectInAppBrowser() {
  if (typeof navigator === "undefined") return null;
  const ua = navigator.userAgent || "";
  if (/Instagram/i.test(ua)) return "instagram";
  if (/FBAN|FBAV|FB_IAB/i.test(ua)) return "facebook";
  if (/TikTok|BytedanceWebview|musical_ly/i.test(ua)) return "tiktok";
  if (/\bLine\//i.test(ua)) return "line";
  if (/;\s*wv\)/i.test(ua)) return "android-webview";
  return null;
}

let initialized = false;

export function initSentry(Vue) {
  if (initialized || !isProd() || !SENTRY_DSN) return;
  initialized = true;

  const inApp = detectInAppBrowser();

  Sentry.init({
    Vue,
    dsn: SENTRY_DSN,
    // Environment propio del front -> separa los eventos del backend (que usa
    // "production") en el selector de Environment del mismo proyecto.
    environment: "frontend-production",
    release: process.env.VUE_APP_RELEASE || undefined,
    // Solo errores: sin trazas de performance, para no consumir la cuota del
    // proyecto compartido con el backend.
    tracesSampleRate: 0,
    // Ruido típico del navegador que no aporta nada.
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications.",
      "Non-Error promise rejection captured",
    ],
    initialScope: {
      tags: {
        side: "client",
        app: "momo-frontend",
        framework: "vue2",
        in_app_browser: inApp || "no",
      },
    },
  });
}

// Reporta fallos de red: un fetch que ni siquiera obtuvo respuesta HTTP
// (el famoso "Failed to fetch"). Incluye contexto suficiente para saber a quién,
// dónde y en qué navegador pasa.
export function captureNetworkError(error, { method, url } = {}) {
  if (!initialized) return;

  Sentry.withScope((scope) => {
    scope.setLevel("error");
    scope.setTag("side", "client");
    scope.setTag("kind", "network_error");
    scope.setTag("in_app_browser", detectInAppBrowser() || "no");
    if (method) scope.setTag("http_method", method);
    if (url) scope.setContext("request", { url, method });
    Sentry.captureException(error);
  });
}
